export const translationConfig: { common: string[]; feature: string } = {
  common: [],
  feature: 'Feature.PeopleList'
};

export default translationConfig;
